import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import NewsHome from './components/NewsHome';
import NewsPage from './components/NewsPage';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Stats from './components/Stats';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Article from './components/Article';
import Advertisement from './components/Advertisement';
import Footer from './components/Footer';
import ComingSoon from './components/ComingSoon';


function AppContent() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-paper text-ink overflow-x-hidden">
      {/* 현재 경로가 '/'가 아닐 때만 Navbar 렌더링 */}
      {location.pathname !== '/' && <Navbar />}

      <Routes>
        <Route path="/" element={<ComingSoon />} />
        <Route path="/home" element={<><Hero /><Services /><Portfolio /><Stats /><Testimonials /></>} />
        <Route path="/QnA" element={<Contact />} />
        <Route path="/news" element={<><NewsHome /><NewsPage /></>} />
        <Route path="/article" element={<Article onBack={() => window.history.back()} />} />
        <Route path="/ad" element={<Advertisement onBack={() => window.history.back()} />} />
      </Routes>

      {/* 현재 경로가 '/'가 아닐 때만 Footer 렌더링 */}
      {location.pathname !== '/' && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}